<template>
  <sale-creation />
</template>

<script>
import SaleCreation from './Requests.SaleCreation'
export default {
  components: {
    SaleCreation
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/requests/index/Requests.Index.vue